module.exports = __webpack_public_path__ + "img/DE01783.dea1bafb.png";